<template>
    <div v-if="items!==null && items.length>0" style="padding:4px;border:1px solid gray;margin:2px;">
        <template v-for="msg in items">
            <div :style="msg.style">
                <div style="text-align:right;"><span class="btn btn-default" @click="close">X</span></div>
                <div>{{msg.msg}}</div>
            </div>
        </template>
    </div>
</template>
<script>
    export default {
        data: function () {
            return {

            };
        },
        computed: {
            items: function () {
                if (this.$store.getters.configs.laws) {
                    return this.$store.getters.configs.laws && this.$store.getters.configs.laws.items;
                }
                return [];
            },
            generalStyle: function () {
                return this.$store.getters.configs.laws.style;
            }
        },
        methods: {
            close: function () {
                this.$emit("onclose");
            }
        },
        created: function () {

        },
        destroyed: function () {

        },
        mounted: function () {

        }
    }
</script>